<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/SDlKEH/tc-custom/9780226042886.jpg?1726274071770" alt="This image is the cover for the book Occupy, TRIOS"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Occupy, TRIOS
      </h1>
      <p class="bookDescription body article font2">
        <i>Mic check! Mic check!</i> Lacking amplification in Zuccotti Park, Occupy Wall Street protestors addressed one another by repeating and echoing speeches throughout the crowd. In <i>Occupy</i>, W. J. T. Mitchell, Bernard E. Harcourt, and Michael Taussig take the protestors’ lead and perform their own resonant call-and-response, playing off of each other in three essays that engage the extraordinary Occupy movement that has swept across the world, examining everything from self-immolations in the Middle East to the G8 crackdown in Chicago to the many protest signs still visible worldwide. “You break through the screen like Alice in Wonderland,” Taussig writes in the opening essay, “and now you can’t leave or do without it.” Following Taussig’s artful blend of participatory ethnography and poetic meditation on Zuccotti Park, political and legal scholar Harcourt examines the crucial difference between civil and political disobedience. He shows how by effecting the latter—by rejecting the very discourse and strategy of politics—Occupy Wall Street protestors enacted a radical new form of protest. Finally, media critic and theorist Mitchell surveys the global circulation of Occupy images across mass and social media and looks at contemporary works by artists such as Antony Gormley and how they engage the body politic, ultimately examining the use of empty space itself as a revolutionary monument. <i>Occupy</i> stands not as a primer on or an authoritative account of 2011’s revolutions, but as a snapshot, a second draft of history, beyond journalism and the polemics of the moment—an occupation itself.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        W.J.T. Mitchell, Bernard E. Harcourt, Michael Taussig
      </h2>
      
      <p class="authorDescription body article"><B>W. J. T. Mitchell</B>&#160;is the Gaylord Donnelley Distinguished Service Professor in the Department of English Language and Literature, the Department of Art History, and the College at the University of Chicago. He is the author, most recently, of&#160;<I>Cloning Terror:&#160;The War of Images, 9/11 to the Present</I>,&#160;published by the University of Chicago Press. He is also coeditor of the journal&#160;<I>Critical Inquiry</I>. <B>Bernard E. Harcourt</B>&#160;is chair of the Department of Political Science and the Julius Kreeger Professor of Law at the University of Chicago. He is the author, most recently, of <I>The Illusion of Free Markets: Punishment and the Myth of Natural Order</I>. <B>Michael Taussig</B>&#160;is the Class of 1933 Professor of Anthropology at Columbia University. He is the author, most recently, of <I>Beauty and the Beast</I>, published by the University of Chicago Press.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?fbe76d0c